<template>
  <div class="step item-box-430">
    <h2 class="title">审批明细</h2>
    <div class="flex item start" v-for="(item, key) in listData" :key="key">
      <div class="icon">
        <Icon :type="getIconType(item, key)" size="32" color="#6149f1" />
      </div>
      <div class="content">
        <p>{{ getStepStr(item) }}</p>
        <p class="time">{{ item.createTime }}</p>
      </div>
      <div class="status">
        <p :style="{ color: getColor(item) }">{{ item | initStepStatus }}</p>
        <p class="name">{{ item.creatorName }}</p>
      </div>
      <div class="status" v-if="[1, 2].includes(item.actType)">
        <p v-if="item.checkRslt == 2">
          <span class="color-red">校验部分通过</span
          ><span
            class="m-16-430 cursor-pointer"
            style="color: #6149f1"
            @click="handleFailList(item)"
            >(查看失败明细)</span
          >
        </p>
        <p v-if="item.checkRslt == 1">
          <span class="color-blue">校验全部通过</span>
        </p>
      </div>
      <!-- 学校确认单 && 未确认 && 学校端 && 具备审批权限   -->
      <!-- isSchCfmAuth == 1 -->
      <div
        class="status"
        v-if="[2].includes(item.actType) && item.isConfirm == 0 && portOrg == 2"
        v-auth="`TEA_SHEET_SCH_AUDIT`"
      >
        <Button type="primary" size="small" @click="handleSchoolCfm"
          >学校确认</Button
        >
      </div>
      <!-- 财务确认节点 && 未确认 && 运营端 && 具备财务确认权限 isAuthority == 1 -->
      <!-- isFinancialCfmAuth == 1 -->
      <div
        class="status"
        v-if="[4].includes(item.actType) && item.isConfirm == 0 && portOrg == 0"
        v-auth="`TEA_SHEET_AUDIT`"
      >
        <Button type="primary" size="small" @click="handleFinancialCfm"
          >财务确认</Button
        >
      </div>
      <div class="status">
        <Button type="primary" @click="handleClickGz" v-if="isShowClickGz(item)"
          >工资发放管理</Button
        >
      </div>
    </div>
    <ApproveSchCfm
      ref="approveSchCfmRef"
      :cfmCountNum="cfmCountNum"
      :sheetId="sheetId"
      @on-finish="onSchCfmFinish"
    ></ApproveSchCfm>
    <ApproveFinancialCfm
      ref="approveFinancialCfmRef"
      :sheetId="sheetId"
      @on-finish="onFinancialCfmFinish"
    >
    </ApproveFinancialCfm>
    <SendCheckGz
      ref="sendCheckGzRef"
      :cfmCountNum="cfmCountNum"
      :schoolId="schoolId"
      :sheetId="sheetId"
      @on-check-finish="onCheckGzFinish"
    ></SendCheckGz>
  </div>
</template>

<script>
import financeCenterApi from '@/request/financeCenter/index.js'
import ApproveSchCfm from './ApproveSchCfm.vue'
import ApproveFinancialCfm from './ApproveFinancialCfm.vue'
import SendCheckGz from './SendCheckGz.vue'
export default {
  components: {
    ApproveSchCfm,
    ApproveFinancialCfm,
    SendCheckGz
  },
  props: {
    sheetId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    },
    detailsInfo: {
      type: Object,
      default: null
    },
    cfmCountNum: {
      type: Object,
      default: () => {
        return {
          abolishNum: 0,
          confirmedNum: 0,
          schoolConfirmNum: 0,
          unconfirmedNum: 0
        }
      }
    }
  },
  data() {
    return {
      listData: [],
      portOrg: localStorage.getItem('portOrg'),
      isPingAnAccount: false, // true 平安进件成功，是平安商户， false 没有平安进件/不是平安商户
    }
  },
  computed: {
    // 学校是否有权限审批
    isSchCfmAuth() {
      return this.$store.state.authMap['TEA_SHEET_SCH_AUDIT']
    },
    // 财务是否有权限审批
    isFinancialCfmAuth() {
      return this.$store.state.authMap['TEA_SHEET_AUDIT']
    },
    // 是否显示 工资发放管理 按钮
    isShowClickGz() {
      return (item) => {
        return this.isPingAnAccount && this.getStepStr(item) == '待结算'
      }
    }
  },
  beforeRouteEnter() {

  },
  created() {
    console.log('this.$store', this.$store)
    this.getSchoolApprovalPayrollList()
    this.getIsPingAnAccount()
  },
  methods: {
    // 财务确认点击
    handleFinancialCfm() {
      this.$refs.approveFinancialCfmRef.handleShow()
    },
    // 学校确认点击
    handleSchoolCfm() {
      this.$refs.approveSchCfmRef.handleShow()
    },
    // 工资发放管理 
    handleClickGz() {
      if (this.detailsInfo && this.detailsInfo.settleSts == 1) {
        this.$Message.warning('工资已经结算，不可再次操作！');
        return null
      }
      this.$refs.sendCheckGzRef.handleShow()
    },
    // 学校确认提交完成
    onSchCfmFinish() {
      this.getSchoolApprovalPayrollList()
      this.$emit('on-schCfmFinish')
    },
    // 财务确认提交完成
    onFinancialCfmFinish() {
      this.getSchoolApprovalPayrollList()
      this.$emit('on-financialCfmFinish')
    },
    onCheckGzFinish() {
      this.getSchoolApprovalPayrollList()
      this.$emit('on-checkGzFinish')
    },
    // 查询是否已平安进件
    async getIsPingAnAccount() {
      let res = await financeCenterApi.getIsPingAnAccountApi({
        orgId: this.schoolId
      })
      if (res.status == 200) {
        this.isPingAnAccount = Boolean(res.message)

      }
    },
    async getSchoolApprovalPayrollList() {
      let res = await financeCenterApi.getSchoolApprovalPayrollListApi({
        sheetId: this.sheetId
      })
      if (res.status == 200) {
        this.listData = res.message.filter(item => { return !([3, 4].includes(Number(item.actType))) })
      }
    },
    // 点击查看 失败明细
    handleFailList(item) {
      this.$emit('on-fail-list', item)
    },
    getIconType(val, key) {

      switch (Number(val.isConfirm)) {
        case 0:
          return 'ios-disc'
          break;
        case 1:
          return 'ios-checkmark-circle'
          break;
        // case 2:
        //   return 'ios-close-circle'
        //   break;


      }
    },

    getColor(val) {
      return '#6149f1'
    },
    getStepStr(item) {
      let str = '运营确认考勤确认单'
      switch (Number(item.actType)) {
        case 1:
          return '运营确认考勤确认单'
          break;
        case 2:
          return '学校确认考勤确认单'
          break;
        case 3:
          return '财务驳回'
          break;

        case 4:
          return '财务确认'
          break;
        case 5:
          switch (Number(item.isConfirm)) {
            case 1:
              return '已结算'
            case 0:
              return '待结算'
            case 2:
              return '结算中'
          }
          // return '结算'
          break;

      }
      return str
    }
  },
  filters: {
    initCheckerName(item) {
      if ([3, 4].includes(item.checkStep)) {
        return item.checkerName
      }
    },
    initStepStatus(item) {
      let str = '未确认'

      if (item.actType == 1 || item.actType == 2) {
        switch (Number(item.isConfirm)) {
          case 0:
            return '待确认'
            break
          case 1:
            return '已确认'
            break

        }
      } else if (item.actType == 3) {
        switch (Number(item.isConfirm)) {
          case 0:
            return '待确认'
            break
          case 1:
            return '已驳回'
            break
          case 2:
            return '已驳回'
            break

        }
      } else if (item.actType == 4) {

        switch (Number(item.isConfirm)) {
          case 0:
            return '待确认'
            break
          case 1:
            return '已通过'
            break

        }
      } else if (item.actType == 5) {

        switch (Number(item.isConfirm)) {
          case 0:
            return '待结算'
            break
          case 1:
            return '已结算'
            break
          case 2:
            return '结算中'
            break

        }
      }

      return str
    },

  },

}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common';
.flex {
  display: flex;
}
.title {
  font-size: 22px;
  margin-bottom: 16px;
}
.item {
  padding-bottom: 32px;
  &:last-child {
    .icon {
      &:before {
        width: 0px;
      }
    }
  }
  .icon {
    margin-right: 8px;
    position: relative;
    &:before {
      position: absolute;
      content: '';
      display: inline-block;
      width: 1px;
      height: 50px;
      background: #eee;
      top: 29px;
      left: 50%;
    }
  }
  .content {
    width: 140px;
  }
  .content,
  .status {
    margin-right: 32px;
    p {
      margin-bottom: 8px;
      font-weight: bold;
    }
    .time,
    .name {
      font-weight: 400;
      color: #999;
    }
  }
  &.end {
    .content {
      display: flex;
      align-items: center;
    }
  }
}
.step {
  position: relative;
}
</style>